/**
 * Do the default transition logic.
 *
 * @param  {JSON} response
 * @param  {ctx} ctx
 * @return {void}
 */
export default (response, ctx) => {
    const page = document.getElementById('page');

    for (let i = 0; i < page.children.length; i++) {
        const child = page.children[i];

        child.classList.add('current-page-content');
    }

    page.classList.add('context-to-work-transition');

    // Pass the component definition to the resolve callback
    EventBus.$once('page-transition-mounted', () => {
        App.router.pageTransitionComplete();
        App.darkHeader = false;

        document.getElementById('page').classList.remove('context-to-work-transition');
        document.documentElement.classList.remove('full-screen');
        TweenMax.set(['.modules-container'], { clearProps: 'all' });

        EventBus.$emit('page-story-init');
    });

    TweenMax.delayedCall(1, () => {
        page.insertAdjacentHTML('beforeend', response.data);

        App.router.buildPage('#page');
    });
};



// WEBPACK FOOTER //
// ./resources/assets/js/navigation/transitions/context-slider-to-work.js